import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import './searchInput.css';

const SearchInput = ({ placeholder, value, onChange, onSearch, type }) => {
  return (
    <div className="search-input-container">

      {/* Show icon ONLY when input empty */}
      {!value && (
        <div className="search-icon">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </div>
      )}

      {type === "number" ? (
        <input
          type="number"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onSearch}
          className="search-input search-input-number"
          min={0}
          max={10}
        />
      ) : (
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onSearch}
          className="search-input"
        />
      )}
    </div>
  );
};

export default SearchInput;